var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSupportTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSupportTicket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.4731942,19.16 C17.0442182,19.16 17.52,19.6327273 17.52,20.2 C17.52,20.7537884 17.0577518,21.24 16.4731942,21.24 C15.8886366,21.24 15.44,20.7537496 15.44,20.2 C15.44,19.6327273 15.9022482,19.16 16.4731942,19.16 Z M16.6283729,11.36 C18.4141268,11.36 19.6,12.293789 19.6,13.5300624 C19.6,14.7663358 18.4141268,15.6606588 18.0374603,15.9368452 C17.2701588,16.502348 17.2561504,16.8968945 17.2561504,17.5807952 C17.2561504,17.8306835 17.1166665,18.12 16.4330554,18.12 C15.8610314,18.12 15.6657539,17.9227079 15.6657539,17.2388449 C15.6657539,16.1078015 16.1959128,15.568559 16.6004761,15.2397765 C17.060873,14.8715281 17.8421428,14.4638514 17.8421428,13.7536149 C17.8421428,13.1486461 17.2840872,12.8592918 16.5865077,12.8592918 C15.1634919,12.8592918 15.4703965,13.871975 14.7170634,13.871975 C14.3403569,13.871975 13.88,13.6352547 13.88,13.1223103 C13.88,12.4121114 14.7449602,11.36 16.6283729,11.36 Z M17,5.64 C22.4611314,5.64 26.88,10.0596019 26.88,15.52 C26.88,20.9811314 22.4603595,25.4 17,25.4 L7.891875,25.4 C7.46556844,25.4 7.12,25.0544316 7.12,24.628125 L7.12,15.52 C7.12,10.0588686 11.5396019,5.64 17,5.64 Z M17,23.85625 C21.6078236,23.85625 25.33625,20.1272061 25.33625,15.52 C25.33625,10.9121764 21.6072061,7.18375 17,7.18375 C12.3921764,7.18375 8.66375,10.9127939 8.66375,15.52 L8.66375,23.85625 L17,23.85625 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NOTIFICATIONS",
    transform: "translate(-21.000000, -112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flag-Copy",
    transform: "translate(14.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icSupportTicket",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSupportTicket);
export default __webpack_public_path__ + "static/media/icSupportTicket.c48855c10b45b3c6575886bb3d08bc82.svg";
export { ForwardRef as ReactComponent };